import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import { BreadcrumbItem } from '../types';

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  onNavigate: (folderId?: string) => void;
  isGlobalDarkMode?: boolean;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, onNavigate }) => {
  return (
    <nav className="flex items-center gap-1">
      <button
        onClick={() => onNavigate()}
        className="flex items-center gap-1 px-2 py-1 text-muted-foreground hover:text-foreground hover:bg-accent rounded-md transition-colors duration-200"
      >
        <Home size={16} />
        <span className="text-sm font-medium">My Drive</span>
      </button>

      {items.map((item, index) => (
        <React.Fragment key={item.id}>
          <ChevronRight size={16} className="text-muted-foreground" />
          <button
            onClick={() => onNavigate(item.id)}
            className={`px-2 py-1 text-sm font-medium rounded-md transition-colors duration-200 ${
              index === items.length - 1
                ? 'text-foreground'
                : 'text-muted-foreground hover:text-foreground hover:bg-accent'
            }`}
          >
            {item.name}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

